// extracted by mini-css-extract-plugin
export var closeButton = "_cj-1";
export var closeX = "_cj-3";
export var container = "_cj-0";
export var image = "_cj-2";